export default {"src":"/_next/static/image/public/icons/arrow-big-white-left.740a7d12ebd3c8ab11dc0138dcd306d8.svg","height":30,"width":30};